import { useState } from "react";
import { EventFragment } from "../../__generated__/graphql";
import DocumentItem from "../../pages/documents/components/DocumentItem";
import Button from "../Button";
import CreateDocumentModal from "../CreateDocumentModal";
import { FaFile } from "react-icons/fa";
import { useEventDetails } from "../EventDetails/context/hook";
import { cn } from "../../lib/utils";

interface EventDocumentsProps {
  event: EventFragment;
  refetchProjectDetails: () => void;
}

export default function EventDocuments({
  event,
  refetchProjectDetails,
}: EventDocumentsProps) {
  const [isCreateDocumentModalOpen, setIsCreateDocumentModalOpen] =
    useState(false);
  const { selectedParticipants } = useEventDetails();

  const documents = event.documents?.map((document) => {
    if (!document) return null;

    const hasParticipantsSelected = document.documentSharings?.some((sharing) =>
      selectedParticipants.some(
        (selectedParticipant) =>
          selectedParticipant.publicUserOrganization.id ===
          sharing.recipientPublicUserOrganization.id
      )
    );

    return (
      <div
        key={document.id}
        className={cn(
          "transition-all duration-300",
          !hasParticipantsSelected &&
            selectedParticipants.length > 0 &&
            !document.isPublic &&
            "opacity-20"
        )}
      >
        <DocumentItem key={document?.id} document={document} />
      </div>
    );
  });

  return (
    <>
      <CreateDocumentModal
        isOpen={isCreateDocumentModalOpen}
        onClose={() => setIsCreateDocumentModalOpen(false)}
        eventId={event?.id}
        onSubmit={() => {
          refetchProjectDetails();
          setIsCreateDocumentModalOpen(false);
        }}
        canBeSharedWithMultiplePerson={true}
      />

      <div className="w-full rounded-md p-4 border border-input">
        <div className="flex justify-between items-center">
          <div className="flex flex-col flex-1">
            <div className="flex justify-between items-center">
              <div className="text-lg font-bold text-primary flex items-center gap-2">
                <FaFile />
                Documents
              </div>
              <Button
                variant="secondary"
                className="text-sm"
                onClick={() => setIsCreateDocumentModalOpen(true)}
              >
                + Ajouter un document
              </Button>
            </div>

            <div className="text-sm text-secondary">
              Ajoutez des documents pour cet évènement. Ils seront accessibles à
              tous les participants ou seulement à une sélection d'entre eux.
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-2 mt-4">{documents}</div>
      </div>
    </>
  );
}
